import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import DealsBoard from '@/components/deals/deals-board'
import { loadCrmPageProps } from '@/lib/crm-page'

const DealsPage: FC<Partial<CrmPageProps>> = ({ data, today }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Deals board" description="Every open deal by stage. Drag a card to move it forward.">
            <PageHeader title="Deals Board" tabs />
            <DealsBoard />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<CrmPageProps> = async () => {
    return { props: await loadCrmPageProps() }
}

export default DealsPage
